import { render, staticRenderFns } from "./PasoDosComponent.vue?vue&type=template&id=73b78c5e&scoped=true"
import script from "./PasoDosComponent.vue?vue&type=script&lang=js"
export * from "./PasoDosComponent.vue?vue&type=script&lang=js"
import style0 from "./PasoDosComponent.vue?vue&type=style&index=0&id=73b78c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b78c5e",
  null
  
)

export default component.exports